import moment from 'moment-timezone';
import momentFr from 'moment/locale/fr';

export function convertToValidMomentDate(previousDate) {
    previousDate = previousDate.replace(", ", " ");
    let datePart = previousDate.split(" ")[0];
    let timePart = previousDate.split(" ")[1];

    let day = datePart.split("/")[0];
    let month = datePart.split("/")[1];
    let year = datePart.split("/")[2];

    let hour = timePart.split(":")[0];
    let minutes= timePart.split(":")[1];
    let seconds = timePart.split(":")[2];

    return year+"-"+month+"-"+day+" "+hour+":"+minutes+":"+seconds;
}


export const getUTCTimestamp = () => {
    return moment().unix();
}

export const timestampToStrDate = (timestamp) => {
    return moment(timestamp, 'X').tz("Europe/Paris").locale('fr').format('ddd D MMM YYYY à HH:mm');
}

export const timestampToStrDay = (timestamp) => {
    return moment(timestamp, 'X').tz("Europe/Paris").locale('fr').format('ddd D MMM');
}

export const timestampToStrHour = (timestamp) => {
    return moment(timestamp, 'X').tz("Europe/Paris").locale('fr').format('HH:mm');
}

export const dateToTimestamp = (date) => {
    return date.getTime()/1000;
}

export const timestampToDate = (timestamp) => {
    return moment(timestamp, "X").tz("Europe/Paris").toDate();
}

export const timestampToStrIso = (timestamp) => {
    return moment(timestamp, "X").tz("Europe/Paris").toISOString();
}

export const utcToTimezone = (timestamp) => {
    return moment(timestamp, "X")
    .add(
      moment(timestamp, 'X').tz("Europe/Paris").utcOffset(), 
      'minutes')
      .unix()
}

export const timezoneToUtc = (timestamp) => {
    return moment(timestamp, "X")
    .subtract(
      moment(timestamp, 'X').tz("Europe/Paris").utcOffset(), 
      'minutes')
      .unix()
}


export const roundPrice = (price) => {
    return Math.round(price*100)/100;
}

export const downloadFile = (url, saveAs) => {
    fetch(url, {headers: {
        "Authorization": "Bearer "+localStorage.getItem('token'),
        "Accept": "application/json",
        "Content-Type": "application/json"
    },}).then((result) => {
        if (result.status != 200) { throw new Error("Bad server response"); }
        return result.blob();
      })
     
      // (C) BLOB DATA
      .then((data) => {
        // (C1) FILE DATA IS "READY FOR USE"
        console.log(data);
     
        // (C2) TO "FORCE DOWNLOAD"
        var url = window.URL.createObjectURL(data),
        anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = saveAs;
        anchor.click();
     
        // (C3) CLEAN UP
        window.URL.revokeObjectURL(url);
        document.removeChild(anchor);
      });
}